import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { iconList } from "./iconList.js";
import icons24spritePath from "../../assets/svg/icons24sprite.5ad9e7b3.svg";
const Icons24 = forwardRef(({ name, dynamicName, size = 24, ...props }, ref) => {
  let nameToUse = name;
  if (dynamicName && iconList.includes(dynamicName)) {
    nameToUse = dynamicName;
  }
  return /* @__PURE__ */ jsx("svg", { ...props, ref, width: size, height: size, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx("use", { href: `${icons24spritePath}#${nameToUse}` }) });
});
export {
  Icons24
};
